import {
  type ButtonActionProps,
  type DropdownActionProps,
  type ButtonWithTooltipActionProps,
  type Action,
} from 'platform/components';

export type EntityHeaderAction =
  | ButtonActionProps
  | DropdownActionProps
  | ButtonWithTooltipActionProps
  | Extract<Action, {type: 'custom' | 'form-button'}>;
